var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignHor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "26px",
    height: "33px",
    viewBox: "-0.5 -0.5 26 33",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2021-12-24T07:09:07.764Z\" agent=\"5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/96.0.4664.110 Safari/537.36\" version=\"16.0.3\" etag=\"kdtoV3oKjV-8Wbof8OkE\" type=\"google\"><diagram id=\"dASRsBO-dY08s-GIHqem\">7VVNb9swDP01Pi6Q/JGmxybt2suAATnsrFmsLVSWAkWpk/360TFl2bDXbkWPkw8WHylS4nuyk2zXnB+dONTfrASdpEyek+w+SdN1xgp8dcilR/hNnvZI5ZQkLAJ79QsIZISelITjJNBbq706TMHSGgOln2DCOdtOw56tnlY9iApmwL4Ueo7+UNLXPbopWMSfQFV1qMwZeRoRggk41kLadgRlD0m2c9b6ftacd6C77oW+9Ou+/sE7bMyB8X+zgPr+KvSJzkb78pdwWDDyrusZWsYaBLe1bzRaHKfOnoyELhlD69kaT2xtyNxZbd01UZbfdw/iR+/sC4w86+tAT18c5Kz98Tx86BLqC2wD3l0whMSV3q42xW0c/XrS2XpFwmsjaYGzesRXwATJpBrKDJW/W4UbGsp+SRlnK56zYWSTyry4GYqHrEd7ciVQojFF/5w7n+X2wlXgZ7lxMmpahK6iWBZI9r5AogY6RbS18rA/iLLztvgBmApGi5+gt6J8qa7LgghIWR8SUFirtF4KrpyQCmIiChdaVQbNEl2A+PYVnFd4x+/I0SgpuyOSKDs3nD8oS+Qw3PiBtYIvyDFdkCN/Q44TZt+gMf9P4yfRmAbWBiLX6RKRxacQiWb8GfTXN/5Ts4ff</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 12.86 30.5 L 12.86 0.5",
    fill: "none",
    stroke: "#666666",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 5.5,
    width: 20,
    height: 10,
    rx: 1.5,
    ry: 1.5,
    fill: "#4d4d4d",
    stroke: "none",
    pointerEvents: "all"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 16.5,
    width: 25,
    height: 10,
    rx: 1.5,
    ry: 1.5,
    fill: "#4d4d4d",
    stroke: "none",
    pointerEvents: "all"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignHor);
export default __webpack_public_path__ + "static/media/align-hor.961b75d0e1384fc4535ec44a8a8e2bbb.svg";
export { ForwardRef as ReactComponent };